// For globals + nav / header // ? [REVISIT] further optimization?
import pTry from 'p-try';
import { render as renderMiniCart } from '../../sections/header/Cart/lazy'; // ? [REVISIT] rename to `renderMiniCart`
import { initSearchBurgerMenu } from '../../sections/header/SearchBurgerNav/initSearchBurgerMenuLazy';
import { renderAtcModal } from '../../templates/_shared/ui-components/ATCModal/renderAtcModalLazy';
import { initShippingCurrencyModal } from '../../templates/_shared/ui-components/ShippingCurrencyModal/initShippingCurrencyModalLazy';
import { render as renderCurrencySelectionFooter } from '../../utils/automaticCurrencyConversion/CurrencySelectionFooter/rederLazy';
import { loaded } from 'src/scripts/utils/document-promises';
import { exposeCustomerOfferFormHandler } from 'src/scripts/utils/customerOfferForm';

import { IS_NATIVE_APP_CLIENT } from 'src/scripts/utils/helpers';
import { autoCouponApplicator } from 'src/scripts/utils/autoCouponApplicator';
import { initDiscountSignupModal } from 'src/scripts/templates/_shared/ui-components/DiscountSignupModal';
import { initSearchForm } from '../../sections/header/Search';
import { initAccountInfoForm } from 'src/scripts/templates/customers/components/AccountInfoForm';
import { renderQuickAddVariantSelector } from '../../sections/header/Cart/components/CartImpulseBuy/QuickAddVariantSelector';
import { currentPathEquals } from '../../utils/localization';
import FACE_ID from 'src/scripts/utils/faceid-helpers';
import { initializeBuilderAddToCartListener } from 'src/scripts/utils/cart';
import { initCountrySpecificFooterContent } from 'src/scripts/templates/_shared/ui-components/CountrySpecificFooterContent';

(async () => {
  renderQuickAddVariantSelector();
  initAccountInfoForm();
  //? [REVISIT] - international checkout should not even be in our standard layout and we should be running all this conditionally on that layout existing.
  if (currentPathEquals('/pages/international-checkout')) return;
  initSearchBurgerMenu();
  initializeBuilderAddToCartListener();
  await loaded;
  renderMiniCart();
  autoCouponApplicator.init();
  pTry(() => {
    if (FACE_ID.showFaceIdEnableModal()) {
      const faceIdPackagePromise = FACE_ID.loadFaceIdScript();
      const modulePromise = import(
        '../../templates/_shared/ui-components/FaceIdEnableConfirmModal/initFaceIdEnableConfirmModal'
      );
      Promise.all([faceIdPackagePromise, modulePromise]).then(([didSucced, module]) => {
        if (didSucced) {
          module.initFaceIdEnableConfirmModal();
        }
      });
    }
  });
  renderAtcModal();
  initShippingCurrencyModal();
  initDiscountSignupModal();
  exposeCustomerOfferFormHandler();
  initSearchForm();
  initCountrySpecificFooterContent();

  if (!IS_NATIVE_APP_CLIENT) {
    renderCurrencySelectionFooter();
  } else {
    //Native app doesn't want this because it uses native ui to make the change across native and webviews
    document.querySelector('footer.footer .currencyselector')?.remove();
  }
})();
